<div class="border-none" [class]="this.className">
  @switch (field.variant) {
      @case('mat-flat-button') {
          <button mat-flat-button mat-elevation-z0 color="accent" class="button" [id]="this.key" [disabled]="getIsDisabled()"
              [type]="this.type">
              @if(this.icon) {
                  <mat-icon [svgIcon]="this.icon" />
              }
          
              @if(this.label) {
                  <span>{{this.label}}</span>
              }
          </button>
      }
      @case('mat-stroked-button') {
          <button mat-stroked-button mat-elevation-z0 class="button" [id]="this.key" [disabled]="getIsDisabled()"
              [type]="this.type">
              @if(this.icon) {
                  <mat-icon [svgIcon]="this.icon" />
              }

              @if(this.label) {
                  <span class="mat-stroked-button-label">{{this.label}}</span>
              }
          </button>
      }
      @default {
          <button mat-fab mat-elevation-z0 color="accent" class="button" [id]="this.key" [disabled]="getIsDisabled()"
              [type]="this.type">
              @if(this.icon) {
                  <mat-icon [svgIcon]="this.icon" />
              }

              @if(this.label) {
                  <span>{{this.label}}</span>
              }
          </button>
      }
  }
</div>